import React, { useEffect } from 'react';
import config from '../../helpers/config';
import { connect } from 'react-redux';
import { fetchRooms } from '../actions';
import Helmet from '../components/Helmet';
import { useLocation, useParams, NavLink } from 'react-router-dom'
import Button from '@material-ui/core/Button';

// add custom style
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Container } from '@material-ui/core';
import EventNoteIcon from '@material-ui/icons/EventNote';
import PageCover from '../components/PageCover';
import LogoBanner from '../components/LogoBanner';

import hash from '../../helpers/hash';
import { DescFrame } from '../components/room';

const useStyles = makeStyles(theme => ({


    joinBtn: props => ({
        height: '100%',
        width: '30%',
        margin: '0 auto',
        paddingTop: '75px',
        
        [theme.breakpoints.down("xs")]: {
            width: '50%',
        },

        '&  h4 > a': {
            letterSpacing: '5px',
            paddingLeft: '5px',
            textAlign: 'center',
            fontWeight: 400,
            color: hash.walk('theme.primary', props) || 'black',
        },

        '&  hr': {
            width: '30%',
        }
    }),

    listItemTextPrimary: {
        marginBottom: "5px",
        '& h4': {
            textAlign: 'left',
            fontWeight: 400,
        }
    },

    hardware: props => ({
        padding: '20px',
        '& h5': {
           fontWeight: '500',
           textAlign: 'left',
           lineHeight: '30px',
           '& span': {
                color: hash.walk('theme.primary', props) || 'white',
            }
        }
    }),

    bannerLogo: props => ({
        backgroundImage: props.bannerContentImgUrl ?'url(' + config.S3Endpoint + props.bannerContentImgUrl + ')' : '',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '85%',
        backgroundPosition: 'center',
        margin: '0 auto',
        height: '300px',
        width: '300px', 
        
        [theme.breakpoints.down("xs")]: {
            height: '150px',
            width: '150px'
        },
    }),

    detail: {
        paddingTop: '40px'
    }
    

}));

const RoomPage = (props) => {

    const location = useLocation(),
        { id } = useParams();

    useEffect(() => {
        props.fetchRooms(location.pathname);
    }, [id])

    const room = room || props.rooms.filter(d => d.id === id)[0],
        classes = useStyles(room);

    if (!room) {
        return <div></div>
    }
    

    const PageCoverProps = {
        ...room,
        style: {
            title: {
                height: '100%',
                transform: "translateZ(1px)",
                '& > div' : {
                    height: '100%',

                    '&  h1': {
                        letterSpacing: '20px',
                        paddingLeft: '20px',
                        color: 'white',
                        textShadow: '1px 1px 4px #000000',
                        textAlign: 'center'
                    },

                    '&  hr': {
                        width: '60%',
                        backgroundColor: 'white',
                        height: '1px'
                    }
                }
            }
        }
    };
    

    return (
        <React.Fragment>
            <Helmet {...room} />

            <div>
                <PageCover {...PageCoverProps}>
                    <Grid container justify="center" alignItems="center">
                        <Grid item>
                            <Typography variant="h1">{room.name}</Typography>
                            <hr />
                        </Grid>
                    </Grid>
                </PageCover>
                
                <LogoBanner {...room} ratio={349 / 395} height={300}>
                    <div className={classes.bannerLogo}></div>
                </LogoBanner>
            
                <DescFrame direction={room.id % 2 === 1 ? 'row' : 'row-reverse'} 
                    imgUrl={room.supportImgUrl1} 
                    title={room.feature}
                    theme={room.theme}>
                    <div className={classes.detail}>
                        {room.detail.desc.map((d, i) => <div key={i}><Typography variant="h4">{d}</Typography></div>)}
                    </div>

                    <div className={classes.joinBtn}>
                        <Typography variant="h4"><a href="tel: 066379888">預約參觀</a></Typography>
                        <hr />
                    </div>
                </DescFrame>

                <DescFrame direction={room.id % 2 === 0 ? 'row' : 'row-reverse'} 
                    imgUrl={room.supportImgUrl2} 
                    title="設備介紹"
                    theme={room.theme}>
                    {room.hardware.map((d, i) => 
                        <Grid key={i} container>
                            <Grid item xs={12} className={classes.listItemTextPrimary}>
                                <Typography variant="h4">|&nbsp;<b>{d.title}</b>&nbsp;|</Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.hardware}>
                                <Grid container item xs={12}>
                                    {d.items.map((item, itemIdx) => 
                                        <Grid key={itemIdx}color="text" item xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <Typography variant="h5"><span>&#10022;</span>&nbsp;{item}</Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </DescFrame>
            </div>
        </React.Fragment>
    )
}

function mapStateToProps({ rooms }) {
    return { rooms };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchRooms()),
    component:  connect(mapStateToProps, { fetchRooms }) (RoomPage)
}



// WEBPACK FOOTER //
// ./src/client/pages/RoomPage.js